import { Icons } from '@beeline/design-tokens/js/iconfont';

export const MAP_ICONS = new Map(
  Object.values(Icons).map(icon => [icon, true])
);
